import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { TimeReportingProjectFormContainerProps } from "models/propTypes/timeReportingProjectPropTypes";
import { NavMenuItem } from "models/propTypes/pageLayoutPropTypes";
//#endregion
//#region components
import { PageLayouts, ViewPanel } from "components/common";
import TimeReportingProjectFormContainer from "./forms/timeReportingProjectFormContainer";
//#endregion
import cssExports from "theme/styles/main.module.scss";

type WrapperProps = TimeReportingProjectFormContainerProps & {
  navKey?: string;
  enableDelayedScrollToTarget?: boolean;
};

const TimeReportingProjectFormNavWrapper: ForwardRefRenderFunction<FormHandles, WrapperProps> = (
  props,
  ref
) => {
  const { navKey = "timeReportingProject", enableDelayedScrollToTarget = false, ...formContainerProps } = props;

  const ProjectFormNavContent: React.FC<{ setNavLayoutSections?: any; title?: any }> = (p) => (
    <ViewPanel className={cssExports.wizardOuter}>
      <TimeReportingProjectFormContainer ref={ref} {...(formContainerProps as any)} {...p} />
    </ViewPanel>
  );

  const navItems: NavMenuItem[] = [
    {
      navKey,
      content: <ProjectFormNavContent />,
    },
  ];

  return <PageLayouts.NavigationLayout navItems={navItems} enableDelayedScrollToTarget={enableDelayedScrollToTarget} />;
};

export default forwardRef(TimeReportingProjectFormNavWrapper);


